import React from "react";

// Icons
import NewFolderIcon from "@material-ui/icons/CreateNewFolder";
import DashboardIcon from "@material-ui/icons/Dashboard";
import PersonIcon from "@material-ui/icons/Person";
import TouchAppIcon from "@material-ui/icons/TouchApp";
//import ControlCameraIcon from "@material-ui/icons/ControlCamera";
import DialpadIcon from "@material-ui/icons/Dialpad";

// Components
import Dashboard from "../Views/Dashboard.jsx";
import Webmaster from "../Views/WebmasterNew.jsx";
import Register from "../Views/Register.jsx";
import Tapper from "../Views/Tapper.jsx";
// import Membership from "../Views/Membership";
import Landing from "../Views/Landing";

//import QRScanner from "../Views/QRScanner.jsx";
import NumericTapper from "../Views/NumericTapper.jsx";

const Routes = [
  {
    path: "/",
    component: Dashboard,
    name: "Dashboard",
    icon: <DashboardIcon />
  },
  {
    path: "/register",
    component: Register,
    name: "Register",
    icon: <NewFolderIcon />
  },
  // {
  //   path: "/loyalty",
  //   component: Membership,
  //   name: "Loyalty",
  //   icon: <PersonIcon />
  // },
  {
    path: "/webmaster",
    component: Webmaster,
    name: "Webmaster",
    icon: <PersonIcon />,
    type: "volunteer"
  },
  {
    path: "/landing",
    component: Landing,
    name: "Landing",
    type: "admin"
  },
  {
    path: "/dialpad",
    component: NumericTapper,
    name: "Keypad",
    icon: <DialpadIcon />,
    type: "volunteer"
  },
  {
    path: "/tapper",
    component: Tapper,
    name: "Timer",
    icon: <TouchAppIcon />,
    type: "admin"
  },
  // {
  // 	path: "/scanner",
  // 	component: QRScanner,
  // 	name: "QR scanner",
  // 	icon: <ControlCameraIcon />,
  // 	type: "admin"
  // },
  { redirect: true, path: "/", to: "/", name: "Redirect" }
];

export default Routes;
